/**
 * Point d'entrée du bundle du back-office.
 *
 * Aucun catalogue de langue à initialiser : A-31 impose le français uniquement, et tous les
 * textes viennent de `src/catalogue/messages.ts`.
 */
import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';

import { App } from './app/App';
import { M } from './catalogue/messages';
import './styles/admin.css';

const racine = document.getElementById('racine');

if (racine === null) {
  // Erreur de montage (index.html incomplet) : message technique, jamais affiché à l'utilisateur.
  throw new Error('Élément racine #racine introuvable dans index.html');
}

document.title = M.app.titre;

createRoot(racine).render(
  <StrictMode>
    <BrowserRouter future={{ v7_startTransition: true, v7_relativeSplatPath: true }}>
      <App />
    </BrowserRouter>
  </StrictMode>,
);
